import { render, staticRenderFns } from "./observation_dashboard.vue?vue&type=template&id=8dfec5c6&scoped=true"
import script from "./observation_dashboard.vue?vue&type=script&lang=js"
export * from "./observation_dashboard.vue?vue&type=script&lang=js"
import style0 from "./observation_dashboard.vue?vue&type=style&index=0&id=8dfec5c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfec5c6",
  null
  
)

export default component.exports